import { Flex, Button } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import useLang from 'lang';
import theme from 'theme';
import H1SemiBold from 'theme/components/Typography/H1SemiBold';
import P2Regular from 'theme/components/Typography/P2Regular';
import { DASHBOARD_PATH } from 'routes/paths';
import SimpleLayout from 'layouts/SimpleLayout';

/**
 * 403 Forbidden page - shown when user doesn't have access to a building
 */
const Forbidden: React.FC = () => {
  const { _t } = useLang();
  const navigate = useNavigate();

  return (
    <SimpleLayout>
      <Flex direction="column" align="center" justify="center" style={{ minHeight: 'calc(100vh - 200px)' }} p="2rem">
        <IconLock size="5rem" color={theme.colors?.red?.[6]} />
        <H1SemiBold color={theme.colors?.gray?.[12]} mt="1.5rem">
          {_t('Access Denied')}
        </H1SemiBold>
        <P2Regular color={theme.colors?.gray?.[9]} mt="1rem" style={{ textAlign: 'center', maxWidth: '500px' }}>
          {_t(
            'You do not have access to this building. Please contact your administrator if you believe this is an error.'
          )}
        </P2Regular>
        <Button size="lg" mt="2rem" onClick={() => navigate(DASHBOARD_PATH.original)}>
          {_t('Go to Dashboard')}
        </Button>
      </Flex>
    </SimpleLayout>
  );
};

export default Forbidden;
